import React, { useState } from "react";
import { FieldArray } from "formik";
import { Thumbnail } from "./Thumbnail";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "axios";

export const ArchivoPreview = ({ values, edit }) => {
    const [modalPrev, setModalPrev] = useState(null);
    const [name, setName] = useState("");

    const renderPreview = (link, name) => {
        axios.get(link, { responseType: "blob" }).then(res => {
            let linkPreview = window.URL.createObjectURL(res.data);
            setModalPrev(linkPreview);
            setName(name);
        });
    };

    const closePrev = () => {
        window.URL.revokeObjectURL(modalPrev);
        setModalPrev(null);
    };

    return (
        <>
            <FieldArray name="archivos">
                {({ remove }) =>
                    (values.archivos || []).map((archivo, index) => (
                        <Thumbnail
                            key={archivo}
                            archivo={archivo}
                            onClose={() => remove(index)}
                            edit={edit}
                            modalPreview={renderPreview}
                        />
                    ))
                }
            </FieldArray>

            {modalPrev && (
                <Modal className="text-center modal-print" isOpen={true} size={"xl"} toggle={closePrev}>
                    <ModalHeader className="justify-content-center title py-1" tag="h6">
                        {name}
                        <button
                            type="button"
                            className="close py-0"
                            title="Cerrar"
                            onClick={closePrev}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>
                    <ModalBody className="py-1">
                        <iframe
                            title="iframe"
                            className="w-100"
                            src={modalPrev}
                            style={{ height: "calc(100vh - 200px)" }}
                        />
                    </ModalBody>
                </Modal>
            )}
        </>
    );
};
